import { Team } from './interfaces';

export const getTeams = async (): Promise<Team[]> => {
  return (await fetch(process.env.REACT_APP_STRAPI_URL + 'Teams')).json();
};
